import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { RandevuIslemleriComponent } from "./randevu-islemleri/randevu-islemleri.component";
import { KimlikBilgisiComponent } from "./kimlik-bilgisi/kimlik-bilgisi.component";
import { PandemiIslemleriComponent } from "./pandemi-islemleri/pandemi-islemleri.component";
import { RandevuVerComponent } from "./randevu-ver/randevu-ver.component";
import { RandevulistesiComponent } from "./randevulistesi/randevulistesi.component";
import { TurcasoftBekciService } from "./services/turcasoft-bekci.service";

const routes: Routes = [
  { path: "", component: RandevuIslemleriComponent },
  
  { path: "pandemi-islemleri", component: PandemiIslemleriComponent },
  {
    path: "kimlik-bilgisi",
    component: KimlikBilgisiComponent
  },
  {
    path: "randevu-ver",
    component: RandevuVerComponent,
    canActivate: [TurcasoftBekciService],
  },
  {
    path: "randevu-listesi",
    component: RandevulistesiComponent,
    canActivate: [TurcasoftBekciService],
  },

  {
    path: "**",
    redirectTo: "",
    pathMatch: "full",
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
